export const headerKeys = {
  tradeshowStatus: 'tradeshowStatus',
  name: 'name',
  startDate: 'startDate',
  location: 'location',
  platformStatus: 'platformStatus',
  contactAccess: 'contactAccess',
  registeredInterest: 'registeredInterest',
};
